// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { cultivationTypeEnum } from './CultivationTypeEnum';
import { fermentationGroupId } from './FermentationGroup';
import { colorCodeEnum5bdcd50c } from './ColorCodeEnum5bdcd50c';
import { flaskId } from './Flask';
import { fermentationStatusEnum } from './FermentationStatusEnum';
import { mediumRecipeId } from './MediumRecipe';
import { operatorId } from './Operator';
import { equipmentId } from './Equipment';
import { fermentationOutcomeEnum } from './FermentationOutcomeEnum';
import { z } from 'zod';
export const fermentationId = (z.number());
export const fermentation = z.object({
    id: fermentationId,
    name: z.string().nullable(),
    description: z.string().nullable(),
    cultivation_type: cultivationTypeEnum.nullable(),
    started_at: z.date().nullable(),
    ended_at: z.date().nullable(),
    fermentation_group_id: fermentationGroupId.nullable(),
    total_inoculum_added_g: z.string().nullable(),
    color_code: colorCodeEnum5bdcd50c.nullable(),
    seed_flask_id: flaskId.nullable(),
    start_weight_g: z.string().nullable(),
    end_weight_g: z.string().nullable(),
    pre_autoclave_weight_g: z.string().nullable(),
    post_autoclave_weight_g: z.string().nullable(),
    planned_start_date: z.date().nullable(),
    planned_end_date: z.date().nullable(),
    seed_train_fermentation_id: fermentationId.nullable(),
    using_seed_train: z.boolean().nullable(),
    status: fermentationStatusEnum.nullable(),
    medium_recipe_id: mediumRecipeId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    equipment_id: equipmentId.nullable(),
    outcome: fermentationOutcomeEnum.nullable(),
    dashboard_id: z.number().nullable(),
    purpose: z.string().nullable(),
});
export const fermentationInitializer = z.object({
    id: fermentationId.optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    cultivation_type: cultivationTypeEnum.optional().nullable(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    fermentation_group_id: fermentationGroupId.optional().nullable(),
    total_inoculum_added_g: z.string().optional().nullable(),
    color_code: colorCodeEnum5bdcd50c.optional().nullable(),
    seed_flask_id: flaskId.optional().nullable(),
    start_weight_g: z.string().optional().nullable(),
    end_weight_g: z.string().optional().nullable(),
    pre_autoclave_weight_g: z.string().optional().nullable(),
    post_autoclave_weight_g: z.string().optional().nullable(),
    planned_start_date: z.date().optional().nullable(),
    planned_end_date: z.date().optional().nullable(),
    seed_train_fermentation_id: fermentationId.optional().nullable(),
    using_seed_train: z.boolean().optional().nullable(),
    status: fermentationStatusEnum.optional().nullable(),
    medium_recipe_id: mediumRecipeId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    outcome: fermentationOutcomeEnum.optional().nullable(),
    dashboard_id: z.number().optional().nullable(),
    purpose: z.string().optional().nullable(),
});
export const fermentationMutator = z.object({
    id: fermentationId.optional(),
    name: z.string().optional().nullable(),
    description: z.string().optional().nullable(),
    cultivation_type: cultivationTypeEnum.optional().nullable(),
    started_at: z.date().optional().nullable(),
    ended_at: z.date().optional().nullable(),
    fermentation_group_id: fermentationGroupId.optional().nullable(),
    total_inoculum_added_g: z.string().optional().nullable(),
    color_code: colorCodeEnum5bdcd50c.optional().nullable(),
    seed_flask_id: flaskId.optional().nullable(),
    start_weight_g: z.string().optional().nullable(),
    end_weight_g: z.string().optional().nullable(),
    pre_autoclave_weight_g: z.string().optional().nullable(),
    post_autoclave_weight_g: z.string().optional().nullable(),
    planned_start_date: z.date().optional().nullable(),
    planned_end_date: z.date().optional().nullable(),
    seed_train_fermentation_id: fermentationId.optional().nullable(),
    using_seed_train: z.boolean().optional().nullable(),
    status: fermentationStatusEnum.optional().nullable(),
    medium_recipe_id: mediumRecipeId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    equipment_id: equipmentId.optional().nullable(),
    outcome: fermentationOutcomeEnum.optional().nullable(),
    dashboard_id: z.number().optional().nullable(),
    purpose: z.string().optional().nullable(),
});
//# sourceMappingURL=Fermentation.js.map